import axios from "axios";
import { IBuildingSiteDto } from "./building-sites-form-dto.interface";

export const htmlId: string = 'building-sites-form';

export const getLinkToBuildingSitesForm = () => {
    return `/BuildingSite/AddBuildingSite`;
}
export const getLinkToEditBuildingSitesForm = (contractorUuid: string | null = null) => {
    if (contractorUuid === null) {
        return `/BuildingSite/EditBuildingSite/:contractorUuid?`;
    }
    return `/BuildingSite/EditBuildingSite/${contractorUuid}`;
}
export const getLinkToViewBuildingSitesForm = (contractorUuid: string | null = null) => {
    if (contractorUuid === null) {
        return `/BuildingSite/View/:contractorUuid?`;
    }
    return `/BuildingSite/View/${contractorUuid}`;
}
export function addBuildingSite(dto: IBuildingSiteDto) {
    return axios.post(`Contractor/AddBuildingSite`, dto);
}
export function getEditedBuildingSite(contractorUuid: string) {
    return axios.get(`Contractor/GetEditedBuildingSite/${contractorUuid}`);
}
export function updateBuildingSite(dto: IBuildingSiteDto) {
    return axios.post(`Contractor/UpdateBuildingSite`, dto);
}